module.exports = __webpack_public_path__ + "img/Fake_Video-4.3016e242.jpg";